/** Tiny classname joiner — avoids pulling in clsx/tailwind-merge as a dependency. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ")
}
